import { Paper, Typography } from "@mui/material";

/**
 * Vista de respaldo cuando no se encuentra la configuración del tab (`tabs_bofu_config`) de la solicitud:
 * le indica al usuario que contacte al administrador en lugar de mostrar el expediente vacío.
 */
export const PaperConfigMissing = () => (
  <Paper variant="lendia_paper" sx={{ p: "20px 22px" }} data-testid="expediente-config-missing">
    <Typography variant="body1" sx={{ fontWeight: 600, color: "primary.dark", textAlign: "center" }}>
      No pudimos cargar la configuración de tu expediente
    </Typography>
    <Typography variant="body2" sx={{ color: "text.disabled", textAlign: "center", mt: "8px" }}>
      Contacta al administrador para que valide la configuración de documentos de tu solicitud.
    </Typography>
  </Paper>
);
